<template>
  <div>
    <div class="tabs-container">
      <ul :class="{ 'tabs nav-tabs-underline': true, spaceBetween: spaceBetween }">
        <li v-for="tab in tabs" :key="'tab-' + tab.name" :class="{ 'is-active': tab.isActive, 'is-disabled': tab.disabled }">
          <a :href="tab.href" @click="selectTab(tab)" :aria-disabled="tab.disabled">{{ tab.name }}</a>
        </li>
      </ul>
    </div>

    <div class="tabs-content">
      <slot class="tabs-panel"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CpTabs',
  data() {
    return { tabs: [] };
  },
  props: {
    spaceBetween: Boolean,
  },
  created() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name == selectedTab.name;
      });
    },
  },
};
</script>

<style>
/*.tabs-container {
}*/

.tabs {
  display: flex;
  padding: 0;
}
.tabs li {
  list-style: none;
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  font-weight: 400;
  float: none;
  font-size: 16px;
  padding: 10px 50px 10px 0px;
  margin: 0;
  height: auto;
  line-height: 1.1;
  text-align: center;
  flex: 1;
}

.tabs li a {
  color: #787878;
  font-size: 18px;
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  vertical-align: sub;
  text-decoration: none;
  display: flex;
  justify-content: center;
}
.tabs li a:active,
.is-active a {
  text-decoration: none;
  border: none;
  font-weight: bold;
  border-bottom: solid 3px var(--primary6);
  color: var(--primary6) !important;
  font-size: 24px !important;
  padding-bottom: 5px !important;
}

.tabs-panel {
  display: none;
}

.tabs-panel.active {
  display: block;
}

.spaceBetween {
  justify-content: space-between;
}

.tabs li.is-disabled a {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

@media screen and (max-width: 767px) {
  .tabs li {
    padding: 10px;
  }
  .tabs li a {
    font-size: 12px;
  }
  .is-active a {
    font-size: 15px !important;
  }
}
</style>
